import { Box, Link, Paper, Typography } from '@mui/material'
import FileViewWidget, { FileViewItem } from '../../components/file/FileView'
import DocumentRefreshButton from './DocumentRefreshButton'

interface DocumentInfoWidgetProps {
  documentInfo: {
    info: string
    registeredAt: string
    externalRegistrationNumber?: string
    externalRegisteredAt?: string
    clientNames?: string[]
    summary?: string
    files: FileViewItem[]
    link: string
  }
  serviceId: number
}

export default function DocumentInfoWidget({
  documentInfo,
  serviceId
}: DocumentInfoWidgetProps) {
  return (
    <Box>
      <Paper sx={{ padding: '1rem', borderRadius: '1rem' }} elevation={0}>
        <Box display="flex" flexDirection="column" gap={1}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
          >
            <Typography variant="subtitle2" fontWeight="bold" color="black">
              Документ
            </Typography>
            <DocumentRefreshButton serviceId={serviceId} />
          </Box>
          <Box display="flex" flexDirection="column">
            <Typography variant="subtitle2" color="black">
              Регистрационный номер: {documentInfo.info}
            </Typography>
            <Typography variant="subtitle2" color="black">
              Дата регистрации: {documentInfo.registeredAt}
            </Typography>
            {documentInfo.externalRegistrationNumber && (
              <Typography variant="subtitle2" color="black">
                Входящий номер: {documentInfo.externalRegistrationNumber}
              </Typography>
            )}
            {documentInfo.externalRegisteredAt && (
              <Typography variant="subtitle2" color="black">
                Входящая дата: {documentInfo.externalRegisteredAt}
              </Typography>
            )}
          </Box>
          <Box display="flex" flexDirection="column">
            <Typography variant="subtitle2" fontWeight="bold" color="black">
              Контрагенты
            </Typography>
            {documentInfo.clientNames?.length ? (
              documentInfo.clientNames?.map((clientName) => (
                <Typography key={clientName} variant="subtitle2" color="black">
                  {clientName}
                </Typography>
              ))
            ) : (
              <Typography variant="subtitle2" color="black">
                Отсутствуют
              </Typography>
            )}
          </Box>
          {documentInfo.summary && (
            <Box display="flex" flexDirection="column">
              <Typography variant="subtitle2" fontWeight="bold" color="black">
                Краткое содержание документа
              </Typography>
              <Typography variant="subtitle2" color="black">
                {documentInfo.summary}
              </Typography>
            </Box>
          )}

          <Box display="flex" flexDirection="column">
            {!!documentInfo.files.length && (
              <>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  color="black"
                >
                  Файлы
                </Typography>
                <FileViewWidget files={documentInfo.files} />
              </>
            )}
            <Link target="_blank" href={documentInfo.link}>
              Перейти к документу
            </Link>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
